import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchInstantGamesTransitionsHistoryRequest = () => ({
  type: actionTypes.FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_REQUEST,
  name: 'manageInventoryLoadingStatus',
});

export const fetchInstantGamesTransitionsHistorySuccess = (history, pagination) => ({
  type: actionTypes.FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_SUCCESS,
  name: 'manageInventoryLoadingStatus',
  history,
  pagination,
});

export const fetchInstantGamesTransitionsHistoryFailure = () => ({
  type: actionTypes.FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_FAILURE,
  name: 'manageInventoryLoadingStatus',
});

export const fetchInstantGamesTransitionsHistory = (config) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(fetchInstantGamesTransitionsHistoryRequest());

    const { content, ...pagination } = await api.fetchInstantGamesTransitionsHistory(requestParams);
    dispatch(fetchInstantGamesTransitionsHistorySuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY', error);
    dispatch(fetchInstantGamesTransitionsHistoryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-instant-games-transitions-history.actions.js